import { render, staticRenderFns } from "./MailRegistry.vue?vue&type=template&id=971302dc&scoped=true&"
import script from "./MailRegistry.vue?vue&type=script&lang=ts&"
export * from "./MailRegistry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971302dc",
  null
  
)

export default component.exports